export default "__VITE_ASSET__CMFfojOp__"